import React, { useState, useEffect } from 'react';
import { useHistory, useParams } from "react-router-dom";
import axios from "axios";
import { Form } from '@formio/react';
import json_trans from '../translation';
import { resetPermissions } from '../utils';
import config from '../../config.js'

const Add = (ComponentToRenderData) => {
    const url = new URL(window.location.href);
    let URLParams = new URLSearchParams(url.search);
    let HiddenParams = URLParams.toString().replace("%5B","[").replace("%5D","]")
    //Set History Variable for redirect after submit
    let history = useHistory();
    // Define CURRENT Module
    const CurrentModule = ComponentToRenderData.CurrentModule;
    const CurrentModuleObj = JSON.parse(localStorage.getItem(CurrentModule));

    //Get System URL
    const SystemUrl = ComponentToRenderData.SystemUrl;
    const params = useParams();
    params.parent_id =  typeof params.parent_id == "undefined" ? "":params.parent_id;

    const options = {
        language: localStorage.getItem('lang') || "en",
        i18n: json_trans,
        template: 'bootstrap'
    }

    const handleSubmitAdd = (res) => {
        if (res.status == true) {
            if (res.data.redirect) {
                return history.push("/" + res.data.redirect + "/Add/" + res.data.data.id);
            }
            if (CurrentModule == "Page" || CurrentModule == "Role") {
                resetPermissions(CurrentModule)
            } else {
                history.push("/" + CurrentModule);
            }
        }
    }

    return (
        <>

            {CurrentModuleObj.add && CurrentModuleObj.page_add && <div className="card mb-5 mb-xl-8">
                <div className="card-body pt-3">
                    <Form src={SystemUrl + CurrentModule + '?get_create_form=true&parent_id=' + params.parent_id+"&"+HiddenParams} options={options} onSubmit={handleSubmitAdd} />
                </div>
            </div>}
        </>

    );
}

export default Add
